import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { premiumFontCss } from '@root/entities/premium/ui'
import { TrendingEmojiIcon } from '@root/entities/premium/ui'
import { DomUtil } from '@root/shared'

import EMPTY_BG from './assets/blank-preview.inline.svg'

type EmojiPreviewBoxProps = {
  emojiId: string | undefined
  title: string
}

export const EmojiPreviewBox: React.FC<EmojiPreviewBoxProps> = ({
  emojiId,
  title,
}) => {
  return (
    <Root>
      <EmojiContainer $hasPreview={!!emojiId}>
        {emojiId ? (
          <TrendingEmojiIcon emojiId={emojiId} size={68} />
        ) : undefined}
      </EmojiContainer>
      <Title ellipsis>{title}</Title>
    </Root>
  )
}

const Root = styled.div`
  height: 96px;
  padding: 14px;
  gap: 14px;

  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  justify-items: start;
  width: 230px;

  overflow: hidden;
  min-width: 0;

  border-radius: 18px;
  background: var(--appearance-1);
`

const Title = styled(Typography)`
  font-size: 20px;
  font-weight: 700;
  line-height: 115%;
  max-width: 100%;
  white-space: nowrap;

  ${premiumFontCss}
`

const EmojiContainer = styled.div<{ $hasPreview: boolean }>`
  background-size: cover;
  height: 68px;
  width: 68px;
  background: ${({ $hasPreview }) =>
    $hasPreview ? undefined : DomUtil.cssUrl(EMPTY_BG)};
`
